import React from "react";
export const ToastContext = React.createContext({
    toasts: [],
    createToast: () => {},
    removeToast: () => {},
});
